import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MASTER_FEATURE_KEY, MasterState } from './master.reducer';

// Lookup the 'Master' feature state managed by NgRx
const getMasterState = createFeatureSelector<MasterState>(MASTER_FEATURE_KEY);

const getLoaded = createSelector(
  getMasterState,
  (state: MasterState) => state.loaded
);
const getError = createSelector(
  getMasterState,
  (state: MasterState) => state.error
);
const getLoading = createSelector(
  getMasterState,
  (state: MasterState) => state.loading
);
const getEntityDeleteLoading = createSelector(
  getMasterState,
  (state: MasterState) => state.entityDeleteLoading
);
const getAllMaster = createSelector(
  getMasterState,
  getLoaded,
  (state: MasterState, isLoaded) => {
    return isLoaded ? state.list : [];
  }
);
const getSelectedId = createSelector(
  getMasterState,
  (state: MasterState) => state.selectedId
);
const getSelectedMaster = createSelector(
  getAllMaster,
  getSelectedId,
  (master, id) => {
    const result = master.find((it) => it['id'] === id);
    return result ? Object.assign({}, result) : undefined;
  }
);
const getAllShipper = createSelector(
  getMasterState,
  (state: MasterState) => state.shipper
);
const getAllConsignee = createSelector(
  getMasterState,
  (state: MasterState) => state.consignee
);
const getAllNotify = createSelector(
  getMasterState,
  (state: MasterState) => state.notify
);
const getAllDeliveryAgent = createSelector(
  getMasterState,
  (state: MasterState) => state.deliveryAgent
);
const getAllAirportCode = createSelector(
  getMasterState,
  (state: MasterState) => state.airportCode
);
const getAllCarrierCode = createSelector(
  getMasterState,
  (state: MasterState) => state.carrierCode
);
const getAllDestinationAirport = createSelector(
  getMasterState,
  (state: MasterState) => state.destinationAirport
);
const getAllAirline = createSelector(
  getMasterState,
  (state: MasterState) => state.airline
);

export const masterQuery = {
  getLoaded,
  getError,
  getAllMaster,
  getSelectedMaster,
  getAllShipper,
  getLoading,
  getEntityDeleteLoading,
  getAllConsignee,
  getAllNotify,
  getAllDeliveryAgent,
  getAllAirportCode,
  getAllCarrierCode,
  getAllDestinationAirport,
  getAllAirline,
};
